document.addEventListener("DOMContentLoaded", function () {
   const shareBtn = document.querySelector(".share-toggle-btn");
  const shareIcons = document.querySelector(".share-icons");

  shareBtn.addEventListener("click", function () {
    shareIcons.classList.toggle("hidden");
  });
});

document.addEventListener("DOMContentLoaded", function () {

  function getColorFromVariant(variant) {
    if (!variant) return null;

    const productOptions = window.productOptions;
    let color = null;

    productOptions.forEach((opt, index) => {
      if (opt.name.toLowerCase().includes('color')) {
        color = variant.options[index];
      }
    });

    return color;
  }

  function updateImagesByColor(color) {
    const images = document.querySelectorAll(".product-image-item");

    // 👉 Check if ANY image has color tagging
    let hasColorImages = false;

    images.forEach((el) => {
      if (el.dataset.color) {
        hasColorImages = true;
      }
    });

    // 👉 If no color-based images → show all
    if (!hasColorImages) {
      images.forEach(el => el.classList.remove("hidden"));
      return;
    }

    // 👉 If color not found → show all
    if (!color) {
      images.forEach(el => el.classList.remove("hidden"));
      return;
    }

    color = color.toLowerCase();

    images.forEach((el) => {
      const imgColor = el.dataset.color;

      // 👉 If image has no alt → ALWAYS show (important fallback)
      if (!imgColor) {
        el.classList.remove("hidden");
        return;
      }

      if (imgColor === color) {
        el.classList.remove("hidden");
      } else {
        el.classList.add("hidden");
      }
    });
  }

  // 🔁 Variant change event (modern themes)
  document.addEventListener("variant:change", function (event) {
    const variant = event.detail.variant;
    const color = getColorFromVariant(variant);
    updateImagesByColor(color);
  });

  // 🔁 Fallback for dropdown
  document.addEventListener("change", function (e) {
    if (e.target.matches('[name="id"]')) {
      const text = e.target.options[e.target.selectedIndex].text;
      const color = text.split('/')[0]?.trim();
      updateImagesByColor(color);
    }
  });

  // 🟢 Initial load
  setTimeout(() => {
    const firstVariant = document.querySelector('[name="id"]');
    if (firstVariant) {
      const text = firstVariant.options[firstVariant.selectedIndex].text;
      const color = text.split('/')[0]?.trim();
      updateImagesByColor(color);
    }
  }, 300);

});















document.addEventListener("DOMContentLoaded", function () {

  const fullscreen = document.querySelector(".zoom-fullscreen");
  const img = document.querySelector(".zoomed-image");
  const nextBtn = document.querySelector(".zoom-next");
  const prevBtn = document.querySelector(".zoom-prev");
  const closeBtn = document.querySelector(".zoom-close");

  let images = [];
  let currentIndex = 0;
  let zoomed = false;

  // 👉 Collect visible images only
  function getImages() {
    return Array.from(
      document.querySelectorAll(".product-image-item:not(.hidden) .zoom-img")
    );
  }

  function showImage(index) {
    const el = images[index];
    const src = el.getAttribute("data-zoom");

    img.src = src;
    currentIndex = index;

    // reset zoom
    zoomed = false;
    img.style.transform = "scale(1)";
    img.style.cursor = "zoom-in";
  }

  // 👉 Open fullscreen
  document.querySelectorAll(".zoom-img").forEach((el, index) => {
    el.addEventListener("click", function () {
      images = getImages();

      // find correct index among visible images
      currentIndex = images.indexOf(this);

      fullscreen.classList.add("active");
       document.body.classList.add("zoom-open");
      showImage(currentIndex);
    });
  });

  // 👉 Next
  nextBtn.addEventListener("click", function (e) {
    e.stopPropagation();
    currentIndex = (currentIndex + 1) % images.length;
    showImage(currentIndex);
  });

  // 👉 Prev
  prevBtn.addEventListener("click", function (e) {
    e.stopPropagation();
    currentIndex = (currentIndex - 1 + images.length) % images.length;
    showImage(currentIndex);
  });

  // 👉 Click to zoom
  img.addEventListener("click", function (e) {
    e.stopPropagation();

    zoomed = !zoomed;

    if (zoomed) {
      this.style.transform = "scale(2)";
      this.style.cursor = "zoom-out";
    } else {
      this.style.transform = "scale(1)";
      this.style.cursor = "zoom-in";
    }
  });

  // 👉 Mouse move pan
  img.addEventListener("mousemove", function (e) {
    if (!zoomed) return;

    const rect = this.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width * 100;
    const y = (e.clientY - rect.top) / rect.height * 100;

    this.style.transformOrigin = `${x}% ${y}%`;
  });

  // 👉 Close
  closeBtn.addEventListener("click", () => {
  fullscreen.classList.remove("active");
  document.body.classList.remove("zoom-open"); 
});

  fullscreen.addEventListener("click", function (e) {
    if (e.target === fullscreen) {
      fullscreen.classList.remove("active");
      document.body.classList.remove("zoom-open");
    }
  });

});